"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var stateTypes = _interopRequireWildcard(require("../../constants/state.types"));

var _icon = _interopRequireDefault(require("../Icon/icon"));

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

var _compareElementType = _interopRequireDefault(require("../helpers/compare-element-type"));

var _ui = require("../../constants/ui.constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var isIconOnlyChild = function isIconOnlyChild(children) {
  return children.length === 1 && (0, _react.isValidElement)(children[0]) && (0, _compareElementType.default)(children[0], _icon.default);
};

var onClickHandler = function onClickHandler(_ref) {
  var state = _ref.state,
      onClick = _ref.onClick;
  return function (event) {
    if (!state) {
      onClick(event);
    }
  };
};

function Button(_ref2) {
  var children = _ref2.children,
      form = _ref2.form,
      disabled = _ref2.disabled,
      iconLeft = _ref2.iconLeft,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? Button.BUTTON_TYPE : _ref2$type,
      tabIndex = _ref2.tabIndex,
      inverted = _ref2.inverted,
      small = _ref2.small,
      large = _ref2.large,
      fullWidth = _ref2.fullWidth,
      danger = _ref2.danger,
      success = _ref2.success,
      primary = _ref2.primary,
      secondary = _ref2.secondary,
      _ref2$asLink = _ref2.asLink,
      asLink = _ref2$asLink === void 0 ? !primary && !danger && !success && !secondary : _ref2$asLink,
      props = _objectWithoutProperties(_ref2, ["children", "form", "disabled", "iconLeft", "type", "tabIndex", "inverted", "small", "large", "fullWidth", "danger", "success", "primary", "secondary", "asLink"]);

  var filteredChildren = _react.Children.toArray(children).filter(function (child) {
    return child !== null;
  });

  var iconOnlyChild = isIconOnlyChild(filteredChildren);
  var buttonClasses = {
    'co-button': !asLink,
    'co-link': asLink,
    'co-button--icon-left': iconLeft,
    'co-button--loader': !!props.state,
    'co-button--icon': iconOnlyChild
  };
  var allowedModifiers = {
    disabled: disabled,
    danger: danger,
    success: success,
    primary: primary,
    secondary: secondary,
    loadingState: props.state,
    inverted: inverted,
    fullWidth: fullWidth,
    small: small,
    large: large
  };
  var ariaLabel = props.ariaLabel || (iconOnlyChild ? filteredChildren[0].props.name : null);

  var TextChildren = function TextChildren(_ref3) {
    var children = _ref3.children;
    return _react.default.createElement(_styler.default, {
      modifiers: {
        truncated: true
      }
    }, function (classes) {
      return _react.default.createElement("span", {
        className: classes
      }, children);
    });
  };

  return _react.default.createElement(_styler.default, {
    classNames: buttonClasses,
    modifiers: allowedModifiers
  }, function (classes) {
    return _react.default.createElement("button", _extends({
      type: type,
      className: classes,
      onClick: onClickHandler(props),
      disabled: disabled,
      tabIndex: tabIndex,
      "aria-label": ariaLabel,
      form: form
    }, (0, _getNativeProps.default)(props)), filteredChildren.map(function (child, index) {
      return !_react.default.isValidElement(child) && typeof child === 'string' ? _react.default.createElement(TextChildren, {
        key: index
      }, child) : child;
    }));
  });
}

Button.INLINE_LOADING_STATE = stateTypes.INLINE_LOADING;
Button.LOADING_STATE = stateTypes.LOADING;
Button.SUCCESS_STATE = stateTypes.SUCCESS;
Button.ERROR_STATE = stateTypes.ERROR;
Button.SUBMIT_TYPE = 'submit';
Button.BUTTON_TYPE = 'button';
var exclusiveVariations = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)(_ui.PRIMARY, _ui.SECONDARY, _ui.SUCCESS, _ui.DANGER);
var exclusiveSizes = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('small', 'large');
var exclusiveIconOrLink = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('iconLeft', 'asLink');
Button.propTypes = {
  /** {---} One of: @@string@@ @@<span>@@ @@<Image>@@ @@<Icon>@@ */
  children: _propTypes.any.isRequired,

  /** {bool} Mutually exclusive props: @@primary@@ @@secondary@@ @@danger@@ @@success@@ */
  primary: exclusiveVariations,

  /** {bool} Mutually exclusive props: @@primary@@ @@secondary@@ @@danger@@ @@success@@ */
  secondary: exclusiveVariations,

  /** {bool} Mutually exclusive props: @@primary@@ @@secondary@@ @@danger@@ @@success@@ */
  success: exclusiveVariations,

  /** {bool} Mutually exclusive props: @@primary@@ @@secondary@@ @@danger@@ @@success@@ */
  danger: exclusiveVariations,
  inverted: _propTypes.bool,

  /** {bool} Mutually exclusive props: @@asLink@@ @@iconLeft@@; Renders a transparent button with smaller paddings. */
  asLink: exclusiveIconOrLink,

  /** {bool} Mutually exclusive props: @@asLink@@ @@iconLeft@@; To be used with @@fullWidth@@ prop only. */
  iconLeft: exclusiveIconOrLink,
  disabled: _propTypes.bool,

  /** {bool} Required if @@iconLeft@@ is truthy */
  fullWidth: (0, _airbnbPropTypes.requiredBy)('iconLeft', _propTypes.bool),

  /** {bool} Mutually exclusive props: @@small@@ @@large@@ */
  small: exclusiveSizes,

  /** {bool} Mutually exclusive props: @@small@@ @@large@@ */
  large: exclusiveSizes,

  /** {const} One of: @@stateTypes.LOADING@@ @@stateTypes.SUCCESS@@ @@stateTypes.ERROR@@ @@stateTypes.INLINE_LOADING@@ */
  state: (0, _propTypes.oneOf)([stateTypes.LOADING, stateTypes.SUCCESS, stateTypes.ERROR, stateTypes.INLINE_LOADING]),
  onClick: _propTypes.func,

  /** {const} One of: @@Button.SUBMIT_TYPE@@ @@Button.BUTTON_TYPE@@ */
  type: (0, _propTypes.oneOf)([Button.SUBMIT_TYPE, Button.BUTTON_TYPE]),
  tabIndex: _propTypes.string,

  /** Must match the @@id@@ prop from the @@<Form>@@ component it refers to. */
  form: _propTypes.string,

  /** If the only child is an @@<Icon>@@, the Icon's @@name@@ will be the default value of this prop. */
  ariaLabel: _propTypes.string
};

var noop = function noop() {};

Button.defaultProps = {
  onClick: noop
};
var _default = Button;
exports.default = _default;
Button.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Button",
  "props": {
    "type": {
      "defaultValue": {
        "value": "Button.BUTTON_TYPE",
        "computed": true
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "Button.SUBMIT_TYPE",
          "computed": true
        }, {
          "value": "Button.BUTTON_TYPE",
          "computed": true
        }]
      },
      "required": false,
      "description": "{const} One of: @@Button.SUBMIT_TYPE@@ @@Button.BUTTON_TYPE@@"
    },
    "asLink": {
      "defaultValue": {
        "value": "!primary && !danger && !success && !secondary",
        "computed": false
      },
      "type": {
        "name": "custom",
        "raw": "exclusiveIconOrLink"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@asLink@@ @@iconLeft@@; Renders a transparent button with smaller paddings."
    },
    "onClick": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": "{---} One of: @@string@@ @@<span>@@ @@<Image>@@ @@<Icon>@@"
    },
    "primary": {
      "type": {
        "name": "custom",
        "raw": "exclusiveVariations"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@primary@@ @@secondary@@ @@danger@@ @@success@@"
    },
    "secondary": {
      "type": {
        "name": "custom",
        "raw": "exclusiveVariations"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@primary@@ @@secondary@@ @@danger@@ @@success@@"
    },
    "success": {
      "type": {
        "name": "custom",
        "raw": "exclusiveVariations"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@primary@@ @@secondary@@ @@danger@@ @@success@@"
    },
    "danger": {
      "type": {
        "name": "custom",
        "raw": "exclusiveVariations"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@primary@@ @@secondary@@ @@danger@@ @@success@@"
    },
    "inverted": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "iconLeft": {
      "type": {
        "name": "custom",
        "raw": "exclusiveIconOrLink"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@asLink@@ @@iconLeft@@; To be used with @@fullWidth@@ prop only."
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "fullWidth": {
      "type": {
        "name": "custom",
        "raw": "requiredBy('iconLeft', bool)"
      },
      "required": false,
      "description": "{bool} Required if @@iconLeft@@ is truthy"
    },
    "small": {
      "type": {
        "name": "custom",
        "raw": "exclusiveSizes"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@small@@ @@large@@"
    },
    "large": {
      "type": {
        "name": "custom",
        "raw": "exclusiveSizes"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@small@@ @@large@@"
    },
    "state": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "stateTypes.LOADING",
          "computed": true
        }, {
          "value": "stateTypes.SUCCESS",
          "computed": true
        }, {
          "value": "stateTypes.ERROR",
          "computed": true
        }, {
          "value": "stateTypes.INLINE_LOADING",
          "computed": true
        }]
      },
      "required": false,
      "description": "{const} One of: @@stateTypes.LOADING@@ @@stateTypes.SUCCESS@@ @@stateTypes.ERROR@@ @@stateTypes.INLINE_LOADING@@"
    },
    "tabIndex": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "form": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Must match the @@id@@ prop from the @@<Form>@@ component it refers to."
    },
    "ariaLabel": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "If the only child is an @@<Icon>@@, the Icon's @@name@@ will be the default value of this prop."
    }
  }
};